import { TemplateDataModel } from "@/component/Template/TemplateDataModel";



const FORMAT_SYS_NUMBER = 1;
const FORMAT_SYS_PRICE = 2;
const FORMAT_SYS_ORDER_PRICE = 3;
const FORMAT_INT = 4;
const FORMAT_FLOAT = 5;
export const FORMAT_STRING = 6;

export const numberThousandSeparator = (num: number | string) => {
  if (num === undefined || num === null) {
    return '';
  }
  // const formattedNumber = Number(num).toLocaleString('en-ZH', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return Number(num).toLocaleString()
  // return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export const  numberThousandSeparatorByValueType = (num: number | string,valueType:number)=>{
  if(valueType == FORMAT_STRING){
    return num
  }
  return numberThousandSeparator(num)
}

export function formatNumberByTemplate(data:Array<Record<string,any>>,templateFieldsObj:Record<string,Required<TemplateDataModel>['fields'][0]>){
  data = data.map((_item,index) =>{
    let item = {..._item}
    Object.keys(item).forEach(key=>{
      if(templateFieldsObj[key]){
        let valueType = templateFieldsObj[key].valueType
        item[key]= numberThousandSeparatorByValueType(item[key],valueType)
      }
    })
    return {
      ...item,
    }
  })
 return data
}